import React from 'react';
import { FileText, CheckCircle, XCircle, AlertCircle, Copy } from 'lucide-react';

interface UploadStats {
  totalRows: number;
  valid: number;
  errors: number;
  warnings: number;
  duplicates: number;
}

interface StatsCardsProps {
  stats: UploadStats;
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  return (
    <div className="admin-bulk-upload-stats">
      <div className="admin-bulk-upload-stat-card">
        <FileText size={24} className="admin-bulk-upload-stat-icon" />
        <div className="admin-bulk-upload-stat-label">Total Rows</div>
        <div className="admin-bulk-upload-stat-value">{stats.totalRows}</div>
      </div>

      <div className="admin-bulk-upload-stat-card">
        <CheckCircle size={24} className="admin-bulk-upload-stat-icon admin-bulk-upload-stat-icon-success" />
        <div className="admin-bulk-upload-stat-label">Valid</div>
        <div className="admin-bulk-upload-stat-value">{stats.valid}</div>
      </div>

      <div className="admin-bulk-upload-stat-card">
        <XCircle size={24} className="admin-bulk-upload-stat-icon admin-bulk-upload-stat-icon-error" />
        <div className="admin-bulk-upload-stat-label">Errors</div>
        <div className="admin-bulk-upload-stat-value">{stats.errors}</div>
      </div>

      <div className="admin-bulk-upload-stat-card">
        <AlertCircle size={24} className="admin-bulk-upload-stat-icon admin-bulk-upload-stat-icon-warning" />
        <div className="admin-bulk-upload-stat-label">Warnings</div>
        <div className="admin-bulk-upload-stat-value">{stats.warnings}</div>
      </div>

      <div className="admin-bulk-upload-stat-card">
        <Copy size={24} className="admin-bulk-upload-stat-icon" />
        <div className="admin-bulk-upload-stat-label">Duplicates</div>
        <div className="admin-bulk-upload-stat-value">{stats.duplicates}</div>
      </div>
    </div>
  );
};

export default StatsCards;
